import { formatDistanceToNow, format, isValid } from 'date-fns';

/**
 * Safe table date formatter that handles null/undefined/invalid dates
 */
export function formatTableDate(value: string | Date | null | undefined, fallback = '—'): string {
  if (!value) return fallback;
  
  const date = typeof value === 'string' ? new Date(value) : value;
  
  if (!isValid(date)) {
    return fallback;
  }
  
  return format(date, 'MMM d, yyyy');
}

/**
 * Safe relative time formatter 
 */
export function formatRelativeTime(value: string | Date | null | undefined, fallback = '—'): string {
  if (!value) return fallback;
  
  const date = typeof value === 'string' ? new Date(value) : value;
  
  if (!isValid(date)) {
    return fallback;
  }
  
  return formatDistanceToNow(date, { addSuffix: true });
}

/**
 * Safe datetime formatter for detailed views
 */
export function formatDateTime(value: string | Date | null | undefined, fallback = '—'): string {
  if (!value) return fallback;
  
  const date = typeof value === 'string' ? new Date(value) : value;
  
  if (!isValid(date)) {
    return fallback;
  }
  
  return format(date, 'MMM d, yyyy \'at\' h:mm a');
}